module.exports = __webpack_public_path__ + "img/dots.187aefe1.webp";